import React from 'react';
import { ImpBulletItem, ImpFlex } from '../..';
function ImpBulletList({ items, bulletStyle, noGap, type = 'bullet', }) {
    const getLabel = (index) => {
        if (type === 'numeric') {
            return `${index + 1}.`;
        }
        return '•';
    };
    return (React.createElement(ImpFlex, { direction: "column", gap: noGap ? undefined : 's', dataTestId: "bullet-list" }, items.map((item, index) => (React.createElement(ImpBulletItem, { key: index, content: item, bulletStyle: bulletStyle, label: getLabel(index) })))));
}
export default ImpBulletList;
//# sourceMappingURL=ImpBulletList.js.map